<template>
  <div v-show="!(field.hide && field.hide())">

    <md-field :key="name" :class="[
                  { 'md-error': hasRequirements && isInvalid },
                  { 'md-valid': hasRequirements && !isInvalid },
                ]"
    >
      <label>{{field.label}}</label>
      <ul class="search-modal-selections">
        <li v-if="pageMode == 'new'">Record must be created first</li>
        <li v-else-if="pageMode !== 'edit' && !form[name].length">No {{field.label}} selected</li>
        <li v-else v-for="target in computedForm" :key="target.id">
          <a v-if="pageMode != 'new' " :href="'#/' + field.list.editPath + '/' + target.id">
            <template v-if="field.list.targetName">
              <span>{{target[field.list.targetName]}}&nbsp;</span>
            </template>
            <template v-else>
              {{target.name}}
            </template>
          </a>

          <md-button v-if="pageMode != 'new'" class="md-button-tiny md-just-icon md-danger md-simple" @click.stop.native="confirmRemove(target)"><md-icon>close</md-icon></md-button>
        </li>
        <li>
          <md-button v-if="pageMode != 'new'" @click="openSearchModal" class="openSearchModal-button md-button md-just-icon md-simple md-button-tiny">
            <md-icon>add</md-icon>
          </md-button>
        </li>
      </ul>


    </md-field>

    <md-dialog-confirm
      :md-active.sync="confirmDialog.show"
      :md-title="confirmDialog.title"
      :md-content="confirmDialog.content"
      md-confirm-text="Yes"
      md-cancel-text="Cancel"
      @md-cancel="resetDialog"
      @md-confirm="remove"
    />

    <md-dialog :md-active.sync="showSearchModal">
      <md-dialog-title>Search for {{field.label}}</md-dialog-title>
      <md-dialog-content>
        <ElasticList
          :list.sync="field.list"
          :exclude="existingRecordsFilter"
          :filter="filter"
          :relateRecordInput="newRecordInput"
          :relateRecordInputField="field.list.relateRecordInputField"
        ></ElasticList>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-theme-default" @click="closeSearchModal">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

  </div>
</template>

<script>
  import ElasticList from "@/components/DynamicForm/ElasticList";
  import {API, Auth, graphqlOperation} from "aws-amplify";
  import * as mutations from '@/graphql/mutations';
  import * as queries from "@/graphql/queries";
  import * as subscriptions from '@/graphql/subscriptions';
  import aws_exports from "../../../aws-exports";
  import gql from "graphql-tag";


  export default {
    name: "crud-search-modal",
    components: {
      ElasticList
    },
    props: {
      field: {
        type: Object,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      pageMode: {
        type: String,
        required: true
      },
      form: {
        type: Object,
        //required: true
      },
      $vo: {
        type: Object,
        required: true
      },
      recordData: {
        type: Object,
      },
      filter: {
        type: [Array, Object],
      },
      iframeModelId: {
        type: String,
        required: false
      },
      atChangeTargetVal: {
        type: Function
      },
    },
    data() {
      return {
        showSearchModal: false,
        confirmDialog: {
          'show': false,
          'content': "",
          'title': ""
        },
        targetDelete: false,
        inputSubs: {},
        deleteQueue: {}
      }
    },
    apollo: {
      subscriptions: {
        query: function() {
          return gql(queries['searchUsers']);
        },
        variables: {
          filter: { id: { eq: '-1' } },
          limit: 1,
        },
        update: () => [],
      }
    },
    computed: {
      isInvalid: function () {
        let result = false, v = this.getV();
        if (v && Object.keys(v.$params).length && v.$invalid) result = true;
        return result;
      },
      hasRequirements: function () {
        let result = false, v = this.getV();
        if (v && Object.keys(v.$params).length) result = true;
        return result;
      },
      isUnique() {
        if (undefined == this.$vo[this.name].isUnique || this.$vo[this.name].$pending) {
          return true;
        }
        return this.$vo[this.name].isUnique;
      },
      existingRecordsFilter: function () {
        let result = null;
        if (!this || !this.field ||!this.field.list || !this.field.list.editPath) return result;

        let key = this.field.list.editPath;
        let objectName = this.field.list.objectName;
        let idField = this.field.list.idField ? this.field.list.idField : 'id';
        if (this.form[key] && this.recordData && this.recordData[key] && this.recordData[key].items) {
          let items = this.recordData[key].items;
          let filters = [];
          items.forEach(item => {
            let matchObj = {};
            matchObj[idField] = item[objectName].id;
            filters.push({"match": matchObj });
          });
          if (filters.length) {
            result = {"must_not": filters};
          }
        }

        console.log('existingRecordsFilter result', result);
        return result;
      },
      newRecordInput: function () {
        let input = this.field.list.relateRecordInput;
        let routeField = this.field.list.relateRecordRouteField;
        if (this.iframeModelId) {
          input[routeField] = this.iframeModelId;
        } else {
          input[routeField] = this.$route.params.id;
        }

        //bubble count total to appear on tabs
        let totalCount = (this.form.companies ? this.form.companies.length : 0) + 
                         (this.form.accounts ? this.form.accounts.length : 0) +
                         (this.form.services ? this.form.services.length : 0) + 
                         (this.form.products ? this.form.products.length : 0) +
                         (this.form.salesreps ? this.form.salesreps.length : 0)
                         
        /**
         * We should not change badge count when task is loaded from inside case
         * Use the iframeModelId to detect if we are inside case
         * @see
         * https://zeamster.atlassian.net/browse/ATLAS-1853
         */
        if(this.targetDelete){
          if(totalCount == 0 && !this.iframeModelId){
            window.$bus.$emit("badge-changed", 'targets', totalCount)
            this.targetDelete = false;
          }   
        }else{
          if(totalCount && totalCount != 0 && !this.iframeModelId){
            window.$bus.$emit("badge-changed", 'targets', totalCount)
            this.targetDelete = false;
          }    
        }             
        // window.$bus.$emit("badge-changed", 'targets', totalCount)
        return input;
      },
      computedForm: function() {
        if (this.form && this.name && this.form[this.name] && this.form[this.name].length > 0) {
          return this.form[this.name]
        } else {
          return []
        }
      }
    },
    methods: {
      openSearchModal() {
        this.$vo[this.name].$touch();
        this.showSearchModal = true;
      },
      closeSearchModal() {
        this.showSearchModal = false;
        //list.needsRefresh = true;
      },
      resetDialog() {
        this.confirmDialog.title = '';
        this.confirmDialog.content = '';
        this.confirmDialog.item = false;
      },
      async remove() {
        this.$vo[this.name].$touch();
        await this.delete(this.confirmDialog.item);

        //Reset the dialog
        this.resetDialog();
      },
      confirmRemove(item) {
        this.confirmDialog.show = true;
        this.confirmDialog.item = item;

        //build the name first
        let list = this.field.list;

        let nameFields = list.deleteMessageNameFields ? list.deleteMessageNameFields : ['name'];
        let objectName = '';
        nameFields.forEach((nf, index) => {
          objectName += item[nf];
          if (index !== nameFields.length -1) objectName += ' ';
        });

        // without at least 1 character this will use the default on the right
        let title = list.deleteMessageTitle ? list.deleteMessageTitle : "Are you sure you want to remove {objectName}?";
        this.confirmDialog.title = title.replace('{objectName}', objectName);

        //this test is different because we want to allow config of '' to omit the default text
        this.confirmDialog.content = typeof list.deleteMessageText !== 'undefined' ? list.deleteMessageText : `The change cannot be undone.`;

      },
      getV: function () {
        // if (this.$vo && this.name && this.$vo[this.name] && this.$vo[this.name].value !== 'undefined') {
        //   return this.$vo[this.name].value || false;
        if (this.$vo && this.name && this.$vo[this.name] !== 'undefined') {
          return this.$vo[this.name] || false;
        } else {
          return false;
        }
      },
      async delete(item) {
        let list = this.field.list;
        let idField = 'id';

        if (typeof list.deleteQueryIdField !== 'undefined') {
          idField = list.deleteQueryIdField;
        }
        if(list.deleteQueryId == 'deleteTeam') {
          if (item[list.deleteGroupId] != null) {
            let groupIdField = item[list.deleteGroupId].replace(/\s+/g, '_');
            console.log('group name to delete: ', groupIdField);
            var params = {
              GroupName: groupIdField, /* required */
              UserPoolId: aws_exports.aws_user_pools_id, /* required */
            };

            Promise.resolve(Auth.currentAuthenticatedUser())
              .then(user =>
                Auth.currentCredentials()
                  .then(credentials =>
                    Promise.resolve(
                      new AWS.CognitoIdentityServiceProvider({
                        apiVersion: '2016-04-18',
                        credentials: Auth.essentialCredentials(credentials),
                        region: aws_exports.aws_appsync_region
                      })
                    )
                  )
                  .then(client => {
                    var responceGroupData = client.deleteGroup(params).promise();
                    console.log('Responce of delete group', responceGroupData);
                  })
              )
          }
        }

        if(list.deleteSyncQueryId) {
          this.deleteSyncRecord(item);
        }
        
        // perform any clean up activity
        if (list.afterDelete && typeof list.afterDelete === 'function') {
          await list.afterDelete(item);
        }

        this.$c.log(list.pageTitle + " deleting record:", item[idField]);
        await API.graphql(graphqlOperation(mutations[list.deleteQueryId], {input: {"id": item[idField]}}))
          .then( response => {
            // if(( typeof list.deleteRelatedRecord !== 'undefined' )){
            //   this.deleteSyncRecord(response.data[list.deleteQueryId], list.deleteRelatedRecord.record);
            // }
            // this.afterDelete(item)
            
            this.targetDelete = true;
          })
          .catch(error => {
            this.$c.log(list.pageTitle + " delete record error:", error);
          });
      },
    },
    async mounted() {
      /* [i] Run any subscriptions configured for the list (relateList in this scenario) */
      let list = this.field.list;
      if (list && list.subscriptions) {
        this.$loopo(list.subscriptions, (sub, name) => {
          this.$c.log('SUBSCRIPTION CONFIGURED: ' + name);
          if (typeof subscriptions[name] === 'undefined') {
            this.$c.error('SUBSCRIPTION [' + name + '] not found!');
            return;
          }
          let thisFunc = list.subscriptions[name].function;
          this.$apollo.queries.subscriptions.subscribeToMore({
            document: gql(subscriptions[name]),
            updateQuery: (previousResult, { subscriptionData }) => {
              console.log('SUBSCRIPTION ', name, subscriptionData);
              thisFunc({ value: subscriptionData });
            },
          });
        });
      }

      if (this.field.subscribe) {
        let sub, subName;

        /* [i] Subscribe to the model that corresponds to the form input for onCreate */
        sub = this.field.subscribe.onCreate;
        if (sub) {
          let subName = 'onCreate' + sub.model;
          this.inputSubs[subName] = {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: ' + subName);
              let eventRecord = eventData.value.data[subName];
              let eventTarget = eventRecord[sub.target];
              let formFieldItems = this.form[sub.inputField];
              let exists = false;
              formFieldItems.forEach(item => {
                if (item.id === eventTarget.id) {
                  exists = true;
                }
              });
              if (!exists) {
                eventTarget.relateRecordId = eventRecord.id;
                // [i] Update the form array
                formFieldItems.push(eventTarget);
                // [i] Update the recordData array (this is used for filtering the list used in here)
                this.recordData[sub.inputField].items.push(eventRecord);
                if(this.field.label === 'Accounts'){
                  this.atChangeTargetVal()
                }                
                if(this.form.casePersonId){
                  window.$bus.$emit("personList-change", sub.inputField, this.recordData)
                }
              }
            }
          };
        }

        /* [i] Subscribe to the model that corresponds to the form input for onCreate */
        sub = this.field.subscribe.onDelete;
        if (sub) {
          subName = 'onDelete' + sub.model;
          this.inputSubs[subName] = {
            result: null,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: ' + subName);
              let eventRecord = eventData.value.data[subName];

              if (!this.deleteQueue[eventRecord.id]) {
                // [i] "Lock" this eventRecord from being removed more than 1 time
                this.deleteQueue[eventRecord.id] = true;

                let form = this.form;
                let recordData = this.recordData;
                form[sub.inputField].forEach((item, index) => {
                  if (item.relateRecordId === eventRecord.id) {
                    // [i] Update the form array
                    form[sub.inputField].splice(index, 1);
                    // [i] Update the recordData array (this is used for filtering the list used in here)
                    recordData[sub.inputField].items.forEach((rdItem, rdIndex) => {
                      if (rdItem.id === eventRecord.id) {
                        recordData[sub.inputField].items.splice(rdIndex, 1);
                      }
                    });
                  }
                });
                if(this.field.label === 'Accounts'){
                  this.atChangeTargetVal()
                }   
                // [i] Release function "lock"
                delete this.deleteQueue[eventRecord.id];
              }
            }
          };
        }

        this.$loopo(this.inputSubs, (sub, name) => {
          if (typeof subscriptions[name] === 'undefined') {
            this.$c.error('SUBSCRIPTION [' + name + '] not found!');
            return;
          }
          let thisFunc = this.inputSubs[name].function;
          this.$apollo.queries.subscriptions.subscribeToMore({
            document: gql(subscriptions[name]),
            updateQuery: (previousResult, { subscriptionData }) => {
              console.log('SUBSCRIPTION ', name, subscriptionData);
              thisFunc({ value: subscriptionData });
            },
          });
        });
      }
    }
  };
</script>

<style lang="scss" scoped>

</style>
